import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=2ca0bdb3&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca0bdb3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ca0bdb3')) {
      api.createRecord('2ca0bdb3', component.options)
    } else {
      api.reload('2ca0bdb3', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=2ca0bdb3&scoped=true&", function () {
      api.rerender('2ca0bdb3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2lZhoWBVGNBXa/JS/comp/Accordion.vue"
export default component.exports